export const IsProduction = process.env.NODE_ENV
export const REDIRECT_URL = IsProduction == 'production' ? process.env.PRODUCTION_REDIRECT_URL : process.env.LOCAL_REDIRECT_URL

// Google IDs - Only public keys exposed to frontend
export const GOOGLE_CLIENT_ID = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || process.env.GOOGLE_CLIENT_ID
// NOTE: GOOGLE_CLIENT_SECRET_ID should NEVER be used in client-side code
// Use /api/google-auth API route instead

// Facebook IDs - Only public keys exposed to frontend
export const FACEBOOK_CLIENT_ID = process.env.NEXT_PUBLIC_FACEBOOK_CLIENT_ID || process.env.FACEBOOK_CLIENT_ID
// NOTE: FACEBOOK_SECRET_ID should NEVER be used in client-side code
// Use /api/facebook-exchange-code API route instead

// Instagram IDs - Only public keys exposed to frontend
export const INSTAGRAM_CLIENT_ID = process.env.NEXT_PUBLIC_INSTAGRAM_CLIENT_ID || process.env.INSTAGRAM_CLIENT_ID
// NOTE: INSTAGRAM_SECRET_ID should NEVER be used in client-side code
// Use /api/instagram-auth API route instead
export const INSTAGRAM_REQUESTED_SCOPES = [
    'instagram_business_basic',
    'instagram_business_manage_insights',
] as const
export const INSTAGRAM_SCOPE_STRING = INSTAGRAM_REQUESTED_SCOPES.join(',')

// Tiktok IDs - Only public keys exposed to frontend
export const TIKTOK_CLIENT_ID = process.env.NEXT_PUBLIC_TIKTOK_CLIENT_ID || process.env.TIKTOK_CLIENT_ID
// NOTE: TIKTOK_SECRET_ID should NEVER be used in client-side code
// Use /api/tiktok-auth API route instead



export const DELETEMESSAGE = "Are you sure you want to delete?"
export const CHANGESTATUS = "Are you sure you want to change status?"
export const DELETENOTIFICATIONMESSAGE = "Are you sure you want to delete all notifications?"
